<template>
  <v-menu
    bottom
    offset-y
    :nudge-bottom="8"
    elevation-0
    transition="slide-y-transition"
    :close-on-content-click="true"
    content-class="tasklist-row-action-menu__panel"
    data-testid="horizon-role-switcher"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="tasklist-dropdown-btn"
        data-testid="horizon-role-switcher__trigger"
      >
        <img
          src="/img/icons/EyeIcons.svg"
          alt="Eye Icon"
          class="role-switcher__icon"
        />

        <span>{{ currentLabel }}</span>
        <img
          src="/img/icons/downArrow.svg"
          alt="Down Arrow"
          class="role-switcher__chevron ml-1"
        />
      </v-btn>
    </template>

    <div class="tasklist-row-action-menu" data-testid="horizon-role-switcher__list">
      <button
        v-for="role in visibleRoles"
        :key="role.value"
        type="button"
        class="tasklist-row-action-menu__item"
        :class="{ 'role-switcher__item--active': role.value === value }"
        @click="onSelect(role.value)"
        data-testid="horizon-role-switcher__option"
      >
        <span class="tasklist-row-action-menu__item-content">
          <span class="tasklist-row-action-menu__item-label">{{ role.label }}</span>
        </span>
      </button>
    </div>
  </v-menu>
</template>

<script>
import './RoleSwitcher.scss';
import constants from '@/plugins/constants';

const { ROLES } = constants.TASK_LIST_CONSTANTS;

export default {
  name: 'RoleSwitcher',

  props: {
    value: {
      type: String,
      default: ROLES.MANAGER,
    },
    showPreparer: {
      type: Boolean,
      default: true,
    },
    showManager: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    roleConstants() {
      return this.$constants.TASK_LIST_CONSTANTS;
    },

    visibleRoles() {
      const { ROLES, ROLE_OPTIONS } = this.roleConstants;
      return ROLE_OPTIONS.filter((role) => {
        if (role.value === ROLES.PREPARER && !this.showPreparer) return false;
        if (role.value === ROLES.MANAGER && !this.showManager) return false;
        return true;
      });
    },

    currentLabel() {
      const { ROLES, ROLE_DEFINITIONS } = this.roleConstants;
      const match = this.visibleRoles.find((r) => r.value === this.value);
      if (match) return match.label;

      if (this.showManager) {
        const managerOption = this.visibleRoles.find((r) => r.value === ROLES.MANAGER);
        if (managerOption) return managerOption.label;
        return ROLE_DEFINITIONS.MANAGER.label;
      }

      return this.visibleRoles[0]?.label || ROLE_DEFINITIONS.PREPARER.label;
    },
  },

  methods: {
    onSelect(role) {
      if (role === this.value) return;

      this.$emit('input', role);
      this.$emit('change', role);
    },
  },
};
</script>
